import React from 'react'

const footerLinks = [
    {href: "https://www.ensing.nl/faq/", label: "FAQ"},
    {href: "https://www.ensing.nl/algemene-voorwaarden-ensing-autoverhuur/", label: "Algemene voorwaarden Ensing Autoverhuur"},
    {href: "https://www.ensing.nl/disclaimer/", label: "Disclaimer"},
    {href: "https://www.ensing.nl/privacyverklaring/", label: "Privacyverklaring"},
    {href: "https://www.ensing.nl/verhuiswagen-huren-in-apeldoorn/", label: "Verhuiswagen huren in Apeldoorn"},
    {href: "https://www.ensing.nl/?page_id=605", label: "Shortlease"},
]

const EnsingFooter = () => {
    return (
        <>
            <footer className="wl-ensing-footer">
                <div className="container">
                    <div className="wl-ensing-footer__main">
                        <div className="wl-ensing-footer__brand">
                            <a href="https://www.ensing.nl/" target="_top" className="wl-ensing-footer__logoLink">
                                <img
                                    className="wl-ensing-footer__logo"
                                    src="https://www.ensing.nl/wp-content/themes/ensing/build/images/ENSING.png"
                                    alt="Ensing Autoverhuur"
                                />
                            </a>
                            <div className="wl-ensing-footer__socials" aria-label="Ensing social media">
                                <a href="https://www.facebook.com/EnsingAutoverhuur/" target="_blank" rel="noreferrer" aria-label="Facebook">
                                    <i className="bi bi-facebook" aria-hidden="true"/>
                                </a>
                                <a href="https://www.instagram.com/ensingautoverhuur/" target="_blank" rel="noreferrer" aria-label="Instagram">
                                    <i className="bi bi-instagram" aria-hidden="true"/>
                                </a>
                                <a href="https://www.linkedin.com/company/ensing-autoverhuur/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                    <i className="bi bi-linkedin" aria-hidden="true"/>
                                </a>
                            </div>
                        </div>

                        <div className="wl-ensing-footer__details">
                            <div className="wl-ensing-footer__section">
                                <h2>Ensing Autoverhuur Apeldoorn - Hoofd-HUB</h2>
                                <address>
                                    Deventerstraat 41<br/>
                                    7311 LV Apeldoorn<br/>
                                    <span>T </span><a href="tel:+31555790304">055 - 5790304</a><br/>
                                    <span>E </span><a href="mailto:info@ensing.nl">info@ensing.nl</a>
                                </address>
                            </div>

                            <div className="wl-ensing-footer__section">
                                <h2>Openingstijden</h2>
                                <dl className="wl-ensing-footer__hours">
                                    <dt>Maandag t/m vrijdag</dt>
                                    <dd>07:00 - 18:00</dd>
                                    <dt>Zaterdag</dt>
                                    <dd>08:00 - 17:00</dd>
                                    <dt>Zondag</dt>
                                    <dd>10:00 - 12:00</dd>
                                </dl>
                            </div>
                        </div>

                        <div className="wl-ensing-footer__legal">
                            <a
                                href="https://www.ensing.nl/wp-content/uploads/2025/05/Algemene-verhuurvoorwaarden-auto-inclusief-bijlage-deelauto-april-2025.pdf"
                                target="_blank"
                                rel="noreferrer"
                            >
                                BOVAG voorwaarden particulier
                            </a>
                            <a
                                href="https://www.ensing.nl/wp-content/uploads/2025/05/Algemene-huurvoorwaarden-auto-zakelijk-Nederlands-print-15-05-2023.pdf"
                                target="_blank"
                                rel="noreferrer"
                            >
                                BOVAG voorwaarden zakelijk
                            </a>
                            <p>KVK - 96631759</p>
                            <p>BTW - NL867691104B01</p>
                        </div>
                    </div>
                </div>
            </footer>

            <section className="wl-ensing-footerBottom">
                <div className="container">
                    <ul className="wl-ensing-footerBottom__links">
                        {footerLinks.map((link) => (
                            <li key={link.href}>
                                <a href={link.href} target="_top">{link.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </>
    )
}

export default EnsingFooter
